import {
  EMPLOYEE_DEFAULT_ROLE_ITEM,
  RESIDENT_DEFAULT_ROLE_ITEM,
} from '../constants/lixani-default-project-roles';
import { overrideRolePermissionsWithUserPermissions } from './overrideRolePermissionsWithUserPermissions.util';
import { returnTogglableDefaultPermissions } from './returnTogglableDefaultPermissions.util';

export const returnEffectiveUserProjectPermissions = (
  foundUserProjectPermissions,
  allRoles,
  resource
) => {
  let userRoleId;

  let rolePermissions;
  let roleName;

  const appDefaultProjectPermissions = returnTogglableDefaultPermissions();

  if (foundUserProjectPermissions) {
    userRoleId = foundUserProjectPermissions.roleId;

    const projectRoles = allRoles.filter(
      (role) => role.projectId === foundUserProjectPermissions.projectId
    );

    if (userRoleId) {
      const userRole = projectRoles.find((role) => role.roleId === userRoleId);
      if (userRole) {
        rolePermissions = {
          ...appDefaultProjectPermissions,
          ...userRole.permissions,
        };
        roleName = userRole.roleName;
      }
    }
  }

  const resourceDefaultPermissions =
    !resource.employmentType || resource.employmentType === 'EMPLOYEE'
      ? EMPLOYEE_DEFAULT_ROLE_ITEM.permissions
      : RESIDENT_DEFAULT_ROLE_ITEM.permissions;

  const rolePermissionsWithUserPermissions =
    overrideRolePermissionsWithUserPermissions(
      appDefaultProjectPermissions,
      resourceDefaultPermissions,
      rolePermissions,
      foundUserProjectPermissions.permissions
    );

  return {
    rolePermissionsWithUserPermissions,
    roleName,
    userRoleId,
    rolePermissions,
  };
};
